import httpClient from '@/http-client'
export const studentList = data => {
  return httpClient
    .get('/api/report/student-lists', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const studentListExcel = data => {
  return httpClient
    .post('/api/report/student-lists/export-excel', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}

export const studentListForMoeys = data => {
  return httpClient
    .get('/api/report/student-list-for-moeys', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const infoInquiry = data => {
  return httpClient
    .get('/api/report/info-inquiries', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const infoInquiryExcelRawData = attributes => {
  return httpClient
    .post('/api/report/info-inquiries/excels', attributes)
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}

export const studentTransfer = data => {
  return httpClient
    .get('/api/report/student-transfers', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const studentEnrollment = data => {
  return httpClient
    .get('/api/report/student-enrollments', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const transportation = data => {
  return httpClient
    .get('/api/report/transportations', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const classTeaching = data => {
  return httpClient
    .get('/api/report/class-teaching', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const inactiveStudent = data => {
  return httpClient
    .get('/api/report/inactive-students', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const studentExchange = data => {
  return httpClient
    .get('/api/report/student-exchanges', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const reportCard = data => {
  return httpClient
    .get('/api/report/report-cards', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const studentAchievementResult = data => {
  return httpClient
    .get('/api/report/student-achievement-results', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getScoringCycle = Options => {
  return httpClient
    .get('/api/report/scoring/cycle', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const getScoringCycleValue = Options => {
  return httpClient
    .get('/api/report/scoring/cycle-values', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const classAttendance = data => {
  return httpClient
    .get('/api/report/class-attendances', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const classAttendanceExcel = data => {
  return httpClient
    .post('/api/report/class-attendances/export-excel', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}
export const header = (Options = {}) => {
  return httpClient
    .get('/api/report/class-attendances/get-header', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const studentFollowUp = data => {
  return httpClient
    .get('/api/report/student-follow-ups', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const scoringReport = data => {
  return httpClient
    .get('/api/report/scoring-reports', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const partTimeOfMonthly = data => {
  return httpClient
    .get('/api/report/part-time-of-monthlies', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const studentScoreSheet = data => {
  return httpClient
    .get('/api/report/student-score-sheets', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const scoringExport = data => {
  return httpClient
    .post('/api/report/scoring-excels', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}
export const studentPerformance = data => {
  return httpClient
    .get('/api/report/student-performances', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const studentTotalScorePerformance = data => {
  return httpClient
    .get('/api/report/student-total-score-performances', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const monthlyStudentSummaryReport = data => {
  return httpClient
    .get('/api/report/monthly-student-summary-reports', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const exportCardExcel = data => {
  return httpClient
    .post('/api/report/report-cards/export-excel', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}

export const classDailyAttendance = data => {
  return httpClient
    .get('/api/report/class-daily-attendances', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const transcript = data => {
  return httpClient
    .get('/api/report/transcripts', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const getStudentPofileAllBranch = data => {
  return httpClient
    .get('/api/report/student-profiles-all-branches', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export default {
  studentList,
  studentListExcel,
  studentListForMoeys,
  infoInquiry,
  studentTransfer,
  studentEnrollment,
  transportation,
  classTeaching,
  inactiveStudent,
  studentExchange,
  reportCard,
  getScoringCycle,
  getScoringCycleValue,
  classAttendance,
  classAttendanceExcel,
  header,
  studentFollowUp,
  scoringReport,
  studentAchievementResult,
  partTimeOfMonthly,
  infoInquiryExcelRawData,
  studentScoreSheet,
  scoringExport,
  studentPerformance,
  studentTotalScorePerformance,
  monthlyStudentSummaryReport,
  exportCardExcel,
  classDailyAttendance,
  transcript,
  getStudentPofileAllBranch
}
